import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridOnIcon from "@material-ui/icons/GridOn";
import {
  Typography,
  Box,
  Select,
  MenuItem,
  InputLabel,
  Grid,
  Button,
  TextField,
} from "@material-ui/core";
import MovilForm from "./forms/MovilForm";
import AccesoryForm from "./forms/AccesoryForm";
import { ProductTypeService } from "../../../services/productType.service";
import ChipForm from "./forms/ChipForm";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";
import CashCard from "./forms/CashCard";
import { AccesoryService } from "../../../services/accesory.service";
import BackDrop from "../../shared/backdrop/Backdrop";
import { useHistory } from "react-router-dom";
import { importExcelFileProduct } from "./utils.inventory";
import { MovileService } from "../../../services/movile.service";

const usetSyles = makeStyles((theme) => ({
  formControl: {
    border: "1px solid #3246D3",
    padding: theme.spacing(1),
    minWidth: "420px !important",
    width: "41.80vw",
    maxWidth: 750,
  },
}));

const NewProduct = ({
  addAlert,
  detailAlert,
  newProductCreated,
  productPreSelected,
}) => {
  const classes = usetSyles();
  const history = useHistory();
  const [productSelected, setProductSelected] = React.useState(
    productPreSelected || null
  );
  const [productTypeArray, setProductTypeArray] = React.useState([]);
  const [productsByExcel, setProductsByExcel] = React.useState([]);
  const [importExcelFile, setimportExcelFile] = React.useState(false);

  useEffect(() => {
    (async function () {
      try {
        const { data } = await ProductTypeService.getProductTypes();
        setProductTypeArray(data);
      } catch (error) {
        console.log(error);
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
      }
    })();
  }, []);

  useEffect(() => {
    setProductsByExcel([]);
  }, [productSelected]);

  const handleSelectedProduct = (e) => {
    setProductSelected(e.target.value);
  };

  const handleImportExcelFile = (event) => {
    event.preventDefault();
    const {
      target,
      target: { files },
    } = event;
    if (target.value.length === 0) {
      console.log("Suspect Cancel was hit, no files selected.");
      setProductsByExcel([]);
      return;
    }

    addAlert({ showAlert: true });
    importExcelFileProduct(files, productSelected)
      .then((messageObject) => {
        const { severity, message, time, isError, dataArray } = messageObject;
        console.log("isError", isError);
        detailAlert({
          severity,
          message,
          time: time || 3000,
        });
        if (!isError) {
          setProductsByExcel(dataArray);
          console.log("final data ==", dataArray);
        } else setProductsByExcel([]);
      })
      .catch((error) => {
        const { severity, message, time, isError } = error;
        detailAlert({
          severity,
          message,
          time: time || 3000,
        });
      });
  };

  const handleSendExcelFile = async () => {
    console.log("productSelected", productSelected);
    if (productSelected === 1 || productSelected === 2) {
      setimportExcelFile(true);
      setProductsByExcel([]);

      try {
        if (productSelected === 1) {
          /**
           * TODO verificar metodo updateBulkMoviles o upsert
           * y validar en backend cuando se trata de insertar IMEI que ya existe
           */
          const result = await MovileService.updateBulkMoviles(productsByExcel);
          console.log("result bulk movile", result);
        } else {
          const result = await AccesoryService.updateBulkAccesory(
            productsByExcel
          );
          console.log("result bulk accesory", result);
        }
        setimportExcelFile(false);
        setTimeout(
          () =>
            history.push(
              productSelected === 1
                ? "/dashboard/inventario/moviles"
                : "/dashboard/inventario/accesorios"
            ),
          3000
        );
        detailAlert({
          severity: "success",
          message:
            productSelected === 1
              ? "Moviles cargados exitosamente"
              : "Accesorios cargados exitosamente",
        });
      } catch (error) {
        setimportExcelFile(false);
        console.log("error Bulk by excel", error);
        detailAlert({ severity: "error", message: error.msgs });
      }
    } else {
      detailAlert({
        severity: "error",
        message:
          "Para la carga de productos por excel seleccionar Accesorios o Equipo Móvil",
      });
    }
    addAlert({ showAlert: true });
  };

  return (
    <React.Fragment>
      <Grid item>
        <Typography variant="h4">
          <Box mt={3} style={{ fontWeight: "bold", color: "#1C2668" }}>
            Nuevo Producto
          </Box>
        </Typography>

        <Typography variant="body1" component={"div"}>
          <Box mt={2} style={{ color: "#1C2668" }}>
            Sigue los pasos a continuación para agregar un nuevo producto al
            inventario
          </Box>
        </Typography>
        <Grid
          style={{ marginTop: 30 }}
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Grid item xs={5}>
            <InputLabel htmlFor="registro" style={{ marginBottom: 8 }}>
              Tipo de producto
            </InputLabel>
            <Select
              className={classes.formControl}
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={productSelected || ""}
              onChange={(e) => handleSelectedProduct(e)}
            >
              {productTypeArray.map((product, id) => {
                return (
                  <MenuItem key={id} value={product.id}>
                    {product.name}
                  </MenuItem>
                );
              })}
            </Select>
          </Grid>
          <Grid item xs={3}>
            <TextField
              hidden
              id="files"
              onChange={(e) => handleImportExcelFile(e)}
              inputProps={{
                accept:
                  ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
                type: "file",
              }}
            />

            <Button
              disabled={!productsByExcel.length}
              variant="contained"
              onClick={handleSendExcelFile}
              color="primary"
              component="span"
              style={{
                color: "white",
                fontWeight: 700,
                marginTop: 7,
              }}
              endIcon={<GridOnIcon />}
            >
              Guardar
            </Button>
          </Grid>
        </Grid>
      </Grid>
      {productSelected === 1 && (
        <MovilForm newProduct={newProductCreated}></MovilForm>
      )}
      {productSelected === 2 && (
        <AccesoryForm newAccesory={newProductCreated}></AccesoryForm>
      )}
      {productSelected === 3 && <ChipForm newChipCreated={newProductCreated} />}
      {productSelected === 4 && (
        <CashCard cardOptionSelected={newProductCreated} />
      )}
      {importExcelFile && (
        <BackDrop
          style={{
            zIndex: 1,
            color: "#1C2668",
          }}
          isOpen={importExcelFile}
        />
      )}
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(NewProduct);
